import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface ClosePORequest {
  poIds?: any[];
}

const useClosePoApi = () => {
  const call = useCallback(async ({ poIds }: ClosePORequest = {}) => {
    try {
      const res = await axiosInstance.post(api.closePO, poIds);
      return res;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { isLoading, execute } = useAsync(call, false);

  return { closePo: execute, closePoCallLoading: isLoading };
};

export default useClosePoApi;
